export default "__VITE_ASSET__3d82c391__"